import { useParams } from "react-router-dom";

import { Divider2 } from "@/ui2/atoms/Divider";
import type { PatientDetails, UUID } from "@/core/types";

import { PatientData } from "../(header)/components/PatientData";

import { AcuityScoreBadge } from "./components/AcuityScoreBadge";
import { getFormattedAcuityDate } from "./helpers/getFormattedAcuityDate";
import { ReportAcuity } from "./components/ReportAcuity";
// import { Menu as ReportAcuityMenu } from "./components/Menu";

type Props = {
  patientDetails: PatientDetails;
};

export function PatientAcuity({ patientDetails }: Props) {
  const { patientId } = useParams<{ patientId: UUID }>();

  const { acuity_score, acuity_timestamp } = patientDetails;

  if (!acuity_score) return null;

  const formattedAcuityDate = acuity_timestamp
    ? getFormattedAcuityDate(acuity_timestamp)
    : undefined;

  return (
    <>
      <div className="tw:flex tw:items-center tw:justify-between tw:gap-1">
        <dl className="tw:flex tw:flex-col tw:gap-2">
          <PatientData
            className="tw:flex tw:items-center"
            classNameChildren="tw:flex"
            label="Acuity Index"
          >
            <AcuityScoreBadge acuityScore={acuity_score} />
          </PatientData>

          {formattedAcuityDate && (
            <PatientData
              className="tw:text-sm tw:text-text-tertiary tw:*:font-normal"
              label="Updated"
            >
              {formattedAcuityDate}
            </PatientData>
          )}
        </dl>

        {/* TODO: Replace with the new ReportAcuityMenu component, when the flow is ready */}
        {/*<ReportAcuityMenu />*/}
        <ReportAcuity patientId={patientId} />
      </div>

      <Divider2 className="tw:lg:-ml-4" />
    </>
  );
}
